module.exports = __webpack_public_path__ + "assets/img/140.515f18fd.png";